/**
 * @file
 * Behaviors for the Carousel.
 */

/* eslint-disable */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Carousel behaviors.
   *
   * @type {Drupal~behavior}
   */
  if (Drupal && !(Drupal.behaviors && Drupal.behaviors.memoriesCard)) {
    Drupal.behaviors.memoriesCard = {};
    Drupal.behaviors.memoriesCard.attach = function(context) {
      const imagesCarousels = $('.memories-card__images-carousel', context);
      if (imagesCarousels) {
        for (const imagesCarousel of imagesCarousels) {
          try {
            $(imagesCarousel)
              .not('.slick-initialized')
              .slick({
                arrows: true,
                centerMode: true,
                slidesToShow: 1,
                variableWidth: true
              });
          } catch (ex) {}
        }
      }
    };
  }
})(Drupal, jQuery);
